import { render, staticRenderFns } from "./addParametro.vue?vue&type=template&id=06ced56a&scoped=true&"
import script from "./addParametro.vue?vue&type=script&lang=js&"
export * from "./addParametro.vue?vue&type=script&lang=js&"
import style0 from "./addParametro.vue?vue&type=style&index=0&id=06ced56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ced56a",
  null
  
)

export default component.exports